import BulkActionConfirmModal from "./BulkActionConfirmModal";

export default BulkActionConfirmModal